/* ==========================================================================
   DIIP PRODUCT GRID MANUAL — Dots บอกจำนวน Card (เฉพาะมือถือ, โหมดเลื่อนซ้าย-ขวา)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pgm-scroll-container]').forEach(function (container) {
    var wrapper = container.closest('.diip-pgm');
    if (!wrapper) return;

    var dotsContainer = wrapper.querySelector('[data-pgm-dots]');
    if (!dotsContainer) return;

    var dots = dotsContainer.querySelectorAll('[data-pgm-dot-index]');
    var cards = container.querySelectorAll('[data-pgm-card-index]');
    if (!dots.length || !cards.length) return;

    function setActiveDot(index) {
      dots.forEach(function (dot) {
        var dotIndex = parseInt(dot.getAttribute('data-pgm-dot-index'), 10);
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    /*
      DIIP UPDATE: คำนวณว่า "การ์ดไหนอยู่ตำแหน่งซ้ายสุดที่มองเห็นอยู่ตอนนี้"
      จาก scrollLeft จริง เทียบกับตำแหน่ง offsetLeft ของแต่ละการ์ด (แม่นยำ
      กว่าการหารด้วยความกว้างคงที่ เพราะการ์ดแรก/สุดท้ายอาจมี margin ไม่เท่ากัน)
    */
    function getActiveIndex() {
      var scrollLeft = container.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, i) {
        var distance = Math.abs(card.offsetLeft - container.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      return closestIndex;
    }

    var scrollTimeout;
    container.addEventListener('scroll', function () {
      // Debounce เล็กน้อย กัน scroll event ที่ยิงถี่มากจนกระทบ Performance
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        setActiveDot(getActiveIndex());
      }, 50);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-pgm-dot-index'), 10);
        var targetCard = container.querySelector('[data-pgm-card-index="' + index + '"]');
        if (targetCard) {
          container.scrollTo({
            left: targetCard.offsetLeft - container.offsetLeft,
            behavior: 'smooth',
          });
        }
      });
    });

    setActiveDot(0); // ตั้งค่าเริ่มต้นให้ Dot แรก Active ตอนโหลดหน้าเว็บ
  });
});
